module.exports = __webpack_public_path__ + "img/mobilleo-logo-blue.e6c88fe4.png";